module.exports = __webpack_public_path__ + "static/wsu-slack-white.29629a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/wsu-library/wsu-slack-white.png
// module id = 483
// module chunks = 262546004982204